import { GET_CURRENT_OBS_BY_LATLON } from '../actions/currentStationObsActions';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    currentStationObsIsRefreshing: false
};

export function currentStationObs(state = initialState, action) {
    switch (action.type) {
        case LOCATION_CHANGED:
        {
            return initialState;
        }

        case GET_CURRENT_OBS_BY_LATLON.pending:
        {
            return {
                ...state,
                currentStationObs: undefined,
                currentStationObsIsRefreshing: true
            };
        }

        case GET_CURRENT_OBS_BY_LATLON.fulfilled:
        {
            return {
                ...state,
                currentStationObs: action.payload,
                lastError: {},
                currentStationObsIsRefreshing: false
            };
        }

        case GET_CURRENT_OBS_BY_LATLON.rejected:
        {
            return {
                ...state,
                currentStationObs: undefined,
                lastError: action.payload,
                currentStationObsIsRefreshing: false
            };
        }
        default:
        {
            return state;
        }
    }
}
